<div mat-dialog-title>
  <h3>Save Filter Set</h3>
</div>

<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <mat-form-field>
        <input matInput [(ngModel)]="filterSet.name" placeholder="Filter Set Name">
      </mat-form-field>
    </div>
  </div>
  <!-- <div class="row">
  <div class="col-12">
    <mat-checkbox [(ngModel)]="includeHarvests">
      Include Harvests
    </mat-checkbox>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <mat-checkbox [(ngModel)]="includeGroups">
      Include Task Groups
    </mat-checkbox>
  </div>
</div> -->
<div class="row filter-content">
  <div class="col-12">
    <h5>Filters in Set</h5>
    <mat-card>
      <mat-card-content>
        @if (showGroupSummary) {
          <p class="filter-summary-item" (click)="groupShowmore=!groupShowmore">
            <span #groupContent [class.truncate]="!groupShowmore"><b style="font-weight: bolder;">Task Groups:</b> {{groupSummary}} </span>
            @if (!groupShowmore && isEllipsisActive(groupContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (groupShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (showZoneSummary) {
          <p class="filter-summary-item" (click)="zoneShowmore=!zoneShowmore">
            <span #zoneContent [class.truncate]="!zoneShowmore"><b style="font-weight: bolder;">Zones:</b> {{zoneSummary}} </span>
            @if (!zoneShowmore && isEllipsisActive(zoneContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (zoneShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (showPhaseSummary) {
          <p class="filter-summary-item" (click)="phaseShowmore=!phaseShowmore">
            <span #phaseContent [class.truncate]="!phaseShowmore"><b style="font-weight: bolder;">Phases:</b> {{phaseSummary}} </span>
            @if (!phaseShowmore && isEllipsisActive(phaseContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (phaseShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (showTeamSummary) {
          <p class="filter-summary-item" (click)="teamShowmore=!teamShowmore">
            <span #teamContent [class.truncate]="!teamShowmore"><b style="font-weight: bolder;">Teams:</b> {{teamSummary}} </span>
            @if (!teamShowmore && isEllipsisActive(teamContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (teamShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (showUserSummary) {
          <p class="filter-summary-item" (click)="userShowmore=!userShowmore">
            <span #userContent [class.truncate]="!userShowmore"><b style="font-weight: bolder;">Users:</b> {{userSummary}} </span>
            @if (!userShowmore && isEllipsisActive(userContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (userShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (!forAnalytics && showTagSummary) {
          <p class="filter-summary-item" (click)="tagShowmore=!tagShowmore">
            <span #tagContent [class.truncate]="!tagShowmore"><b style="font-weight: bolder;">Tags:</b> {{tagSummary}} </span>
            @if (!tagShowmore && isEllipsisActive(tagContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (tagShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }
        @if (showDateRangeSummary) {
          <p class="filter-summary-item">
            <span #dateRangeContent><b style="font-weight: bolder;">Date Range:</b> {{dateRangeSummary}} </span>
          </p>
        }
        @if (showTaskTypeSummary) {
          <p class="filter-summary-item" (click)="taskTypeShowmore=!taskTypeShowmore">
            <span #taskTypeContent [class.truncate]="!taskTypeShowmore"><b style="font-weight: bolder;">Task Types:</b> {{taskTypeSummary}} </span>
            @if (!taskTypeShowmore && isEllipsisActive(taskTypeContent)) {
              <span class="show-more"><mat-icon>expand_more</mat-icon></span>
            }
            @if (taskTypeShowmore) {
              <span class="show-more"><mat-icon>expand_less</mat-icon></span>
            }
          </p>
        }


      </mat-card-content>
    </mat-card>
  </div>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="save()" [disabled]="saving">
    @if (saving) {
      <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
    }
    @if (!saving) {
      <span>Save</span>
    }
  </button>
</mat-dialog-actions>